<template v-slot>
  <div :class="b()" ref="feedback">
    <CardFeedback :departmentId="null" :doctorId="this.docId" type="doctor" />
  </div>
</template>

<script>
import CardFeedback from "components/card-feedback/CardFeedback";
import * as names from "store/names";
import { mapGetters } from "vuex";

export default {
  name: "DoctorCardFeedback",
  components: { CardFeedback },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      docId: names.DOCTOR_ID,
    }),
  },

  methods: {
    scrollTo(){
      this.$refs.feedback.scrollIntoView({behavior: 'smooth'})
    },
  },
};
</script>

<style scoped lang="scss">
@import "~scss/helpers/helpers";
</style>
